import styled from 'styled-components';

export const FooterWrapper = styled.div`
  padding: 0 2%;
  background-color: var(--fourth-color);
  color: var(--color-text-footer);

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  a {
    text-decoration: none;
  }
`;

export const FooterSocialIconsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 22px;
  width: 25%;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    margin-top: 20px;
  }

  img {
    cursor: pointer;
  }

  a {
    text-decoration: none;
  }
`;

export const FooterTopInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 30px 0 0;
  flex-wrap: wrap;
`;

export const LogoWrapper = styled.div`
  width: 25%;

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    margin-bottom: 15px;
  }

  img {
    width: 180px;
  }
`;

export const TextWrapper = styled.div`
  width: 35%;
  font-size: var(--font-medium);

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const FooterNavInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 70px;
  width: 100%;
  padding-bottom: 25px;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: 40px;
    gap: 28px;
  }

  a {
    color: var(--color-text-footer);
    cursor: pointer;
    text-decoration: none;
    font-size: var(--font-medium);
  }
`;

export const ExeltisLogo = styled.div`
  text-align: right;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    margin-top: 25px;
  }

  .line {
    flex: 1;
    display: flex;

    &::before {
      content: '';
      display: inline-block;
      width: 100%;
      height: 1px;
      background-color: var(--color-text-footer);
    }
  }
`;
